<template>
  <sc-select
    v-model="logsReverseStatus"
    :loading="loadingListStatus"
    :disabled="loadingListStatus"
    expanded>
    <option 
      :value="null">
      {{ optionAll ? 'Todos' : 'Selecione' }}</option>
    <option
      v-for="status in listStatus"
      :value="status.value"
      :key="status.value">
      {{ status.label }}
    </option>
  </sc-select>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex';
  import {
    ScSelect,
  } from '@intelipost-js/secure-components';

  const {
    mapState,
    mapActions,
  } = createNamespacedHelpers('analytic/logsReverse');

  export default {
    name: 'sc-logs-reverse-status',
    props: {
      value: {
        type: [Number, String],
        default: null,
      },
      optionAll: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        logsReverseStatus: this.value,
      };
    },
    watch: {
      value(value) {
        this.logsReverseStatus = value;
      },
      logsReverseStatus(logsReverseStatus) {
        this.$emit('input', logsReverseStatus);
      },
    },
    computed: {
      ...mapState([
        'loadingListStatus',
      ]),
      listStatus() {
        return [{
          value: 'ERROR',
          label: 'Erro',
        }, {
          value: ' SCHEDULED',
          label: 'Agendado',
        },
        {
          value: 'SUCCESS',
          label: 'Sucesso',
        }, {
          value: 'PROCESSING',
          label: 'Processando',
        },
        ];
      },
    },
    methods: {
      ...mapActions([
        'getlogsReverse',
      ]),
    },
    beforeMount() {},
    components: {
      ScSelect,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/reverse/components/sc-logs-reverse-status/ScLogsReverseStatus.vue?7249ae14